class LoggedIn {
    public element: HTMLElement;
    public status: Boolean;
    public redirectUrl: string = '';

    bindings() {
        this.status = this.element.dataset.status == '1' ? true : false;
        if (this.status == true) {
            // Body class
            document.body.classList.add('is-user');

            // Replace popup target email if loggedin at e.g. downloads
            var targetEmailPopupEls = document.querySelectorAll('[data-target=popup-email]') as NodeListOf<HTMLElement>;
            targetEmailPopupEls.forEach((el) => {
              el.dataset.target = 'none';
              el.dataset.toggle = 'none';
            });

            const targetDownloadModalEls = document.querySelectorAll('[data-download-id]') as NodeListOf<HTMLElement>;
            targetDownloadModalEls.forEach((el) => {
              el.dataset.target = 'none';
              el.dataset.toggle = 'none';
              el.addEventListener('click', () => {
                const apiBaseUrl = document.body.dataset.apiBaseUrl;
                const idFile = el.dataset.downloadId;
                const slugFile = el.dataset.downloadSlug;
                const lang = document.documentElement.lang.slice(0, 2);
                const directDownloadUrl = apiBaseUrl + 'download/' + slugFile + '?lang=' + lang;
                // @ts-ignore
                const newWindow = window.open(directDownloadUrl, '_blank');
                // @ts-ignore
                newWindow.focus();
              });
            });

            // tbd.
        }
        else {
          document.body.classList.add('not-user');
        }

        this.redirectUrl = this.element.dataset.redirectUrl ?? '';
        if (this.redirectUrl != '') {
          this.setCookie('GeoMateRedirectOverride', '1', 30);
          var langInputs = document.querySelectorAll('.js-ls-language') as NodeListOf<HTMLInputElement>;
          if (this.redirectUrl == 'FORCE_DE' || this.redirectUrl == 'FORCE_EN' || this.redirectUrl == 'FORCE_CH') {
            langInputs.forEach(langInput => {
              if (
                (this.redirectUrl == 'FORCE_DE' && langInput.dataset.langiso == 'de-DE')
                || (this.redirectUrl == 'FORCE_EN' && langInput.dataset.langiso == 'en-US')
                || (this.redirectUrl == 'FORCE_CH' && langInput.dataset.langiso == 'de-CH')
              ) {
                this.redirectUrl = `${langInput.value}`;
              }
            });
          }

          if (window.location.search != '') {
            if (this.redirectUrl.includes('?')) {
              this.redirectUrl = this.redirectUrl + window.location.search.replace('?', '&');
            }
            else {
              this.redirectUrl = this.redirectUrl + window.location.search;
            }
          }

          window.location.href= `${this.redirectUrl}`;
        }
    }

    cache() {
      this.element = document.querySelector('.logged-in-cmp') as HTMLElement;
    }

    init() {
      this.cache();
      this.bindings();
    }

    setCookie(cName: string, cValue: string, expDays: number) {
      let date = new Date();
      date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    }
  }

  export default LoggedIn;
